/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Customer-portal applications are worked in the v2 look only
 * (docs/ui-v2/RE_PORTAL.md 5c); the classic sidenav doesn't list them. A
 * classic user who follows a link here (an email to the agent) is told where
 * to find it rather than shown a half-styled page.
 */

import React from "react";
import Alert from "@mui/material/Alert";
import RePage from "../../screens/components/RePage";

export default function ClassicNotice() {
  return (
    <RePage title="Applications">
      <Alert severity="info">
        Applications from your website are in the new Pearl CRM look. Switch to it from your profile menu to review them.
      </Alert>
    </RePage>
  );
}
